<template>
    <div>
        <DefaultHeader :cart="this.cart" :show-cart="true"></DefaultHeader>
        <section class="min-margin pt-0 pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-12 bg-white p-5">
                        <h1 class="mb-5">Winkeltje</h1>
                        <p>Bestel hier je favoriete educatieve materiaal. Je kunt direct afrekenen via iDEAL. Normaliter heb je je bestelling binnen een week in huis.</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-secondary">
            <div class="container">
                <div class="row grid">
                    <article v-for="product in this.products" class="col-md-6 col-lg-4 col-xxl-4 mb-4">
                        <div class="card">
                            <img class="card-img-top" :src="product.image" :alt="product.title">
                            <div class="card-body">
                                <h5 class="card-title mb-3">{{ product.title }}</h5>
                                <div class="card-text" v-html="product.htmlText"></div>

                                <div class="btn-wrapper d-flex align-items-center">
                                    <button :class="'btn btn-sm' + (!product.active ? ' disabled' : '')" @click="addToCart(product)">
                                        <i class="fad fa-shopping-cart"></i>
                                        <span v-if="product.active">Bestel</span>
                                        <span v-if="!product.active">Uitverkocht</span>
                                    </button>
                                    <strong class="ms-auto me-2">&euro; {{ cart.parsePrice(product.basePrice) }}</strong>
                                    <i class="fad fa-info-circle" data-bs-toggle="popover" title="Extra informatie"
                                       :data-bs-content="product.helpText"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </section>
        <DefaultFooter></DefaultFooter>
        <CartModal :cart="cart" :parentUpdateQuantity="updateQuantity" :parentRemoveFromCart="removeFromCart" ref="cartModal"></CartModal>
    </div>
</template>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s
}

.fade-enter-active {
    transition-delay: .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0
}

.slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

</style>

<script>
import Product from '../entities/Product';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import Popover from 'bootstrap/js/src/popover';
import Cart from '../entities/Cart';
import CartItem from '../entities/CartItem';
import DefaultHeader from "./defaults/DefaultHader";
import CartModal from "./defaults/CartModal";
import DefaultFooter from "./defaults/DefaultFooter";

const products = require('../repositories/products.json');

export default {
    name:       'Home',
    components: { DefaultFooter, CartModal, DefaultHeader },
    data() {
        return {
            products: [],
            cart:     new Cart([])
        }
    },
    methods: {
        addToCart(product) {
            this.cart.add(
                new CartItem({
                    product: product
                })
            )

            this.updateStore();

            this.$refs.cartModal.orderFormStep = 1;
            this.$refs.cartModal.openCart();
        },
        updateQuantity(event, cartItem) {
            if(event.target.value === '') {
                return;
            }
            event.target.value = parseInt(event.target.value);
            event.target.value = event.target.value === 'NaN' ? cartItem.quantity : event.target.value;

            if(parseInt(event.target.value) <= 0) {
                this.removeFromCart(cartItem.product.id);
            } else {
                cartItem.update({
                    quantity: event.target.value
                })
            }

            this.updateStore();
        },
        removeFromCart(event, key) {
            event.preventDefault();
            this.cart.remove(key);

            this.updateStore();
        },

        updateStore() {
            this.$store.commit('cart/updateState', this.cart);
        },
    },
    created() {
        for(let i in products.products) {
            this.products.push(
                new Product(products.products[i])
            );
        }
    },
    mounted() {
        const gridElement = this.$el.querySelector('.grid');
        new imagesLoaded(gridElement, () => {
            new Masonry(this.$el.querySelector('.grid'), {
                percentPosition: true
            });
        });

        document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
            new Popover(el);
        });


        if(typeof this.$store.state.cart.items !== 'undefined') {
            this.cart = Cart.makeFromJson(this.$store.state.cart);
        }
    }
}
</script>
